<template>
  <div class="exhibition-info">
    <!-- 顶部导航栏 -->
    <AppHeader />

    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-background">
        <div class="city-skyline">
          <img src="@/images/index2.png" alt="港口背景" class="skyline-image" />
        </div>
      </div>
      <div class="banner-content">
        <h1 class="banner-title">展会信息</h1>
        <p class="banner-subtitle">最新展会资讯与信息</p>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="content">
        <!-- 图片展示区域 -->
        <div class="exhibition-gallery">
          <div 
            v-for="(image, index) in exhibitionImages" 
            :key="index"
            class="image-container"
            @click="openImagePreview(index)"
          >
            <img 
              :src="image.url" 
              :alt="`展会信息图片 ${index + 1}`"
              class="exhibition-image"
              @error="handleImageError"
            />
            <div class="image-number">{{ index + 1 }}</div>
            <div class="image-overlay">
              <div class="preview-icon">🔍</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 底部区域 -->
    <AppFooter />
    
    <!-- 图片预览模态框 -->
    <div v-if="showPreview" class="preview-modal" @click="closePreview">
      <div class="preview-content" @click.stop>
        <div class="preview-header">
          <h3>展会信息图片预览 ({{ currentPreviewIndex + 1 }}/{{ exhibitionImages.length }})</h3>
          <button class="close-btn" @click="closePreview">×</button>
        </div>
        <div class="preview-body">
          <div class="preview-nav prev-btn" @click="prevImage" v-if="currentPreviewIndex > 0">‹</div>
          <img 
            :src="exhibitionImages[currentPreviewIndex].url" 
            :alt="`展会信息图片 ${currentPreviewIndex + 1}`"
            class="preview-image"
          />
          <div class="preview-nav next-btn" @click="nextImage" v-if="currentPreviewIndex < exhibitionImages.length - 1">›</div>
        </div>
        <div class="preview-footer">
          <div class="image-counter">
            <span 
              v-for="(image, index) in exhibitionImages" 
              :key="index"
              class="counter-dot"
              :class="{ active: index === currentPreviewIndex }"
              @click="goToImage(index)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'ExhibitionInfo',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      showPreview: false,
      currentPreviewIndex: 0,
      exhibitionImages: [
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-2.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-3.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-4.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-5.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-6.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-7.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-8.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-9.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-10.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-11.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-12.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-13.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/2026imagesE-1.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-1.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-2.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-3.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-4.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-5.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-6.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-7.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-8.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-9.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-10.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-11.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-12.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-13.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-14.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-15.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-16.jpg' },
        { url: 'https://chb.hnjsxk.com/app/static/image/zhanhui/imagesE-17.jpg' }
      ]
    }
  },
  methods: {
    handleImageError(event) {
      console.error('图片加载失败:', event.target.src)
      event.target.style.display = 'none'
    },
    openImagePreview(index) {
      this.currentPreviewIndex = index
      this.showPreview = true
      document.body.style.overflow = 'hidden'
    },
    closePreview() {
      this.showPreview = false
      document.body.style.overflow = 'auto'
    },
    prevImage() {
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--
      }
    },
    nextImage() {
      if (this.currentPreviewIndex < this.exhibitionImages.length - 1) {
        this.currentPreviewIndex++
      }
    },
    goToImage(index) {
      this.currentPreviewIndex = index
    },
    handleKeydown(event) {
      if (!this.showPreview) return
      
      switch(event.key) {
        case 'Escape':
          this.closePreview()
          break
        case 'ArrowLeft':
          this.prevImage()
          break
        case 'ArrowRight':
          this.nextImage()
          break
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
    document.body.style.overflow = 'auto'
  }
}
</script>

<style scoped>
.exhibition-info {
  width: 100%;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  background-color: white;
  padding-top: 0;
}

/* Banner区域样式 */
.banner {
  position: relative;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.city-skyline {
  left: 0;
  width: 100%;
  height: 100%;
}

.skyline-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  margin: 0 0 10px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-subtitle {
  font-size: 18px;
  margin: 0;
  opacity: 0.9;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* 主要内容区域 */
.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  min-height: calc(100vh - 300px);
}

.content {
  width: 100%;
  background: white;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid #e0e0e0;
  padding: 30px;
}

/* 图片展示区域 */
.exhibition-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.image-container {
  position: relative;
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.image-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.image-container:hover .image-overlay {
  opacity: 1;
}

.exhibition-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
}

.image-number {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(74, 144, 226, 0.9);
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  z-index: 2;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.preview-icon {
  font-size: 24px;
  color: white;
}

/* 预览模态框样式 */
.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.preview-content {
  background: white;
  border-radius: 8px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.preview-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.preview-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.preview-body {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 400px;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.preview-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.preview-nav:hover {
  background: rgba(0, 0, 0, 0.7);
}

.prev-btn {
  left: 20px;
}

.next-btn {
  right: 20px;
}

.preview-footer {
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
}

.image-counter {
  display: flex;
  gap: 8px;
}

.counter-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ddd;
  cursor: pointer;
  transition: background 0.3s ease;
}

.counter-dot.active {
  background: #4A90E2;
}

.counter-dot:hover {
  background: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    padding: 10px;
  }
  
  .content {
    padding: 15px;
  }
  
  .exhibition-gallery {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .exhibition-image {
    height: 200px;
  }
  
  .banner-title {
    font-size: 36px;
  }
  
  .banner-subtitle {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .exhibition-gallery {
    grid-template-columns: 1fr;
  }
  
  .exhibition-image {
    height: 180px;
  }
}
</style>